import { useContext, useState } from 'react'
import ClientContext from 'contexts/ClientContext'
import classNames from 'classnames'
import style from './CardLine.module.scss'

const CardLine = ({ className, content, styles, suffix, title }) => {
  const { color, colabelNeutralDark } = useContext(ClientContext)

  return (
    <div className={classNames(style['card-line'], className)} style={{ ...styles }}>
      <div>
        {title && <span className={style.title} style={color && {color: colabelNeutralDark}}>{title}</span>}
        {content && <span className={style.content}>{content}</span>}
      </div>
      {suffix && <div className={style.suffix}>{suffix}</div>}
    </div>
  )
}

export default CardLine
